import BrowsingHistoryProducts from './BrowsingHistoryProducts';

import { connect } from 'react-redux';

import { analyticsActions } from 'src/analytics/store';

interface IDispatchFromProps {
  fireProductImpressionEvent(data: any): void;
  fireProductClickEvent(data: any): void;
}

const mapStateToProps = (state: any) => ({
  isLoggedIn: state.signin.success
});

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  fireProductImpressionEvent: (data: any) =>
    dispatch(analyticsActions.productImpression(data)),
  fireProductClickEvent: (data: any) =>
    dispatch(analyticsActions.productClick(data))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BrowsingHistoryProducts);
